import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { faRev } from "@fortawesome/free-brands-svg-icons";
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import Eth from "../assets/images/eth.png";
import Usd from "../assets/images/usd.png";
import Dai from "../assets/images/dai.png";
import Tet from "../assets/images/tet.png";
import Bin from "../assets/images/bin.png";
import Cha from "../assets/images/cha.png";
import Tab from "react-bootstrap/Tab";
import { Button, Modal, Row, Col, Nav, CloseButton } from "react-bootstrap";
import ToggleSwitch from "../Modals/ToggleSwitch";
import "./ModelTwo.css";

function ModelTwo() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div className="model-wraper manage">
        <Button className="Swap_model" onClick={handleShow}>
          <FontAwesomeIcon icon={faBars} />
          <span className="manage">Manage</span>
        </Button>
        <Modal
          show={show}
          onHide={handleClose}
          animation={false}
          className="swap_tabsmodel_2"
        >
          <Modal.Header>
            <div className="w-100 ">
              <span className=" d-flex flex-fill arrowLeft">
                <span className="cur-poi" onClick={handleClose}>
                  <FontAwesomeIcon icon={faArrowLeft} />
                </span>
              </span>
              <div className="token-text d-flex">
                <h4 className="text-center w-100"> Manage</h4>
                <CloseButton variant="white" onClick={handleClose} />
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3 tabs-section">
              <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <Row>
                  <Col sm={12}>
                    <Nav
                      variant="pills"
                      className="flex-row justify-content-center"
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="first">Lists </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Token</Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Col>
                  <Col sm={12}>
                    <Tab.Content>
                      <Tab.Pane eventKey="first">
                        <div className="d-felx model--info">
                          <div className="form-group has-search">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="http:// or ipfs:// or ENS name"
                            />
                          </div>
                        </div>
                        <div className="info--part">
                          <div className="lower-section">
                            <div className="d-flex ms-md-4 ms-2">
                              <span className="logo-area">
                                <img src={Eth} alt="" />
                              </span>
                              <div className="description d-flex flex-fill">
                                <h6>Cardano</h6>
                                <p>CAO</p>
                              </div>
                              <div className="d-flex align-items-center  me-md-4 me-2 ">
                                <ToggleSwitch />
                              </div>
                            </div>
                          </div>
                          <div className="lower-section">
                            <div className="d-flex ms-md-4 ms-2">
                              <span className="logo-area">
                                <img src={Usd} alt="" />
                              </span>
                              <div className="description d-flex flex-fill">
                                <h6>USA Coin</h6>
                                <p>USDC</p>
                              </div>
                              <div className="d-flex align-items-center me-md-4 me-2">
                                <ToggleSwitch />
                              </div>
                            </div>
                          </div>
                          <div className="lower-section">
                            <div className="d-flex ms-md-4 ms-2">
                              <span className="logo-area">
                                <img src={Dai} alt="" />
                              </span>
                              <div className="description d-flex flex-fill">
                                <h6>Dai Stablecoin</h6>
                                <p>Dai</p>
                              </div>
                              <div className="d-flex align-items-center me-md-4 me-2">
                                <ToggleSwitch />
                              </div>
                            </div>
                          </div>
                          <div className="lower-section">
                            <div className="d-flex ms-md-4 ms-2">
                              <span className="logo-area">
                                <img src={Tet} alt="" />
                              </span>
                              <div className="description d-flex flex-fill">
                                <h6>Tether USD</h6>
                                <p>USDT</p>
                              </div>
                              <div className="d-flex align-items-center me-md-4 me-2">
                                <ToggleSwitch />
                              </div>
                            </div>
                          </div>
                          <div className="lower-section">
                            <div className="d-flex ms-md-4 ms-2">
                              <span className="logo-area">
                                <img src={Dai} alt="" />
                              </span>
                              <div className="description d-flex flex-fill">
                                <h6>Dai Stablecoin</h6>
                                <p>Dai</p>
                              </div>
                              <div className="d-flex align-items-center me-2 me-md-4">
                                <ToggleSwitch />
                              </div>
                            </div>
                          </div>
                          <div className="lower-section">
                            <div className="d-flex ms-md-4 ms-2">
                              <span className="logo-area">
                                <img src={Usd} alt="" />
                              </span>
                              <div className="description d-flex flex-fill">
                                <h6>USA Coin</h6>
                                <p>USDC</p>
                              </div>
                              <div className="d-flex align-items-center me-md-4 me-2">
                                <ToggleSwitch />
                              </div>
                            </div>
                          </div>
                          <div className="lower-section">
                            <div className="d-flex ms-md-4 ms-2">
                              <span className="logo-area">
                                <img src={Eth} alt="" />
                              </span>
                              <div className="description d-flex flex-fill">
                                <h6>Cardano</h6>
                                <p>CAO</p>
                              </div>
                              <div className="d-flex align-items-center  me-md-4 me-2">
                                <ToggleSwitch />
                              </div>
                            </div>
                          </div>
                          <div className="lower-section">
                            <div className="d-flex ms-md-4 ms-2">
                              <span className="logo-area">
                                <img src={Bin} alt="" />
                              </span>
                              <div className="description d-flex flex-fill">
                                <h6>Binance USD</h6>
                                <p>BUSD</p>
                              </div>
                              <div className="d-flex align-items-center me-md-4 me-2">
                                <ToggleSwitch />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second" className="custom-token">
                        <div className="d-flex justify-content-center align-items-center ms-2 ms-md-4 me-md-4 me-2">
                          <div className="tip-section">
                            <h3>
                              Tips:
                              <span className="token-detail">
                                Custom tokens are stored locally in your browser
                              </span>
                            </h3>
                          </div>
                        </div>
                        <div className="info---token">
                          <div className="d-flex justify-content-between mt-3 ms-2 ms-md-4 me-md-4 me-2 ">
                            <div className="d-flex justify-content-center align-items-center">
                              <h5>3 Custom Token</h5>
                            </div>
                            <div className="d-flex justify-content-center align-items-center">
                              <h6>Clear</h6>
                            </div>
                          </div>
                          <div className="d-flex justify-content-between divider">
                            <div className="d-flex justify-content-center align-items-center ms-md-4 ms-2">
                              <span className="code-part"></span>
                              <h5>BUSD</h5>
                            </div>
                            <div className="d-flex justify-content-center align-items-center me-md-4 me-2">
                              <a href="#" target="_blank">
                                <FontAwesomeIcon icon={faTrashAlt} />
                              </a>
                              <a href="#" target="_blank">
                                <FontAwesomeIcon icon={faRev} />
                              </a>
                            </div>
                          </div>
                          <div className="d-flex justify-content-between  divider">
                            <div className="d-flex justify-content-center align-items-center ms-md-4 ms-2">
                              <span className="code-part"></span>
                              <h5>BUSD</h5>
                            </div>
                            <div className="d-flex justify-content-center align-items-center me-md-4 me-2">
                              <a href="#" target="_blank">
                                <FontAwesomeIcon icon={faTrashAlt} />
                              </a>
                              <a href="#" target="_blank">
                                <FontAwesomeIcon icon={faRev} />
                              </a>
                            </div>
                          </div>
                          <div className="d-flex justify-content-between  divider">
                            <div className="d-flex justify-content-center align-items-center ms-md-4 ms-2">
                              <span className="code-part"></span>
                              <h5>BUSD</h5>
                            </div>
                            <div className="d-flex justify-content-center align-items-center me-md-4 me-2">
                              <a href="#" target="_blank">
                                <FontAwesomeIcon icon={faTrashAlt} />
                              </a>
                              <a href="#" target="_blank">
                                <FontAwesomeIcon icon={faRev} />
                              </a>
                            </div>
                          </div>
                          <div className="d-flex justify-content-between  divider">
                            <div className="d-flex justify-content-center align-items-center  ms-md-4 ms-2">
                              <span className="code-part"></span>
                              <h5>BUSD</h5>
                            </div>
                            <div className="d-flex justify-content-center align-items-center me-md-4 me-2">
                              <a href="#" target="_blank">
                                <FontAwesomeIcon icon={faTrashAlt} />
                              </a>
                              <a href="#" target="_blank">
                                <FontAwesomeIcon icon={faRev} />
                              </a>
                            </div>
                          </div>
                          <div className="d-flex justify-content-between mt-3">
                            <div className="d-flex justify-content-center align-items-center ms-md-4 ms-2">
                              <span className="code-part"></span>
                              <h5>BUSD</h5>
                            </div>
                            <div className="d-flex justify-content-center align-items-center me-md-4 me-2">
                              <a href="#" target="_blank">
                                <FontAwesomeIcon icon={faTrashAlt} />
                              </a>
                              <a href="#" target="_blank">
                                <FontAwesomeIcon icon={faRev} />
                              </a>
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </div>
          </Modal.Body>
          {/* <Modal.Footer>
            <div className="d-flex jusify-content-center align-items-center footer-content">
              <a href="#" target="_blank">
                <FontAwesomeIcon icon={faBars} />
              </a>
              <h2>Manage</h2>
            </div>
          </Modal.Footer> */}
        </Modal>
      </div>
    </>
  );
}

export default ModelTwo;
